/**
 * Undo 機能（NPC バトル専用）の定数。
 *
 * - 1 Play につき 1 回だけ、広告視聴スタブで解放できる。
 * - 解放後に押すと、直前のプレイヤー手 + それに対する AI 応答をまとめて巻き戻す。
 * - 永続化しない（新しいゲーム開始時にリセット）。
 *
 * 将来実広告 SDK に差し替える場合は `services/adsStub.ts` の実装のみ置き換える
 * 現在のゲームデザインでは Undo 広告導線は無効化されている。
 *
 * 参考ルール:
 *   - `.claude/rules/no-hardcode.md`
 *   - `.claude/rules/no-silent-fallback.md`
 */

/**
 * 1 Play で使用できる Undo の最大回数。
 * 現仕様では 1 固定だが、バランス調整で変更する可能性があるため定数化する。
 */
export const UNDO_MAX_PER_PLAY = 1

/** Undo が解放済み・使用可能なときのボタンラベル。 */
export const UNDO_BUTTON_LABEL = 'Undo'

/** Undo がまだ解放されていない（広告未視聴）ときのボタンラベル。 */
export const UNDO_UNLOCK_LABEL = 'Undo（広告で解放）'

/** Undo を使い切ったときのボタンラベル。 */
export const UNDO_USED_LABEL = '使用済み'

/** 広告スタブ視聴中（解放処理中）に表示するラベル。 */
export const UNDO_UNLOCKING_LABEL = '広告再生中…'
